const API_URL = process.env.REACT_APP_LOCAL_API;
const API_TOKEN = process.env.REACT_APP_LOCAL_API_TOKEN;

const getRandomTemplates = async (page, pagination, is_video) => {
  if (!pagination || !page) {
    return;
  }
  const URL = `${API_URL}/api/random_templates/v2?page=${page}&pagination=${pagination}&is_video=${is_video || false}&only_videos=${is_video || false}&origin=web`;

  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: {
        Authorization: `token ${API_TOKEN}`,
      },
    });

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} - ${response.statusText}`);
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching getRandomTemplates:", error);
    throw error;
  }
};

const addCategoryWithTemplates = async (data) => {
  const formdata = new FormData();
  formdata.append("category_name", data.name);
  formdata.append("animated_preview", data.animated_preview);
  // formdata.append("order", data.category_order);
  // formdata.append("is_top_collection", data.is_top_collection);
  // formdata.append("order", data.order);
  // formdata.append("is_featured", data.is_featured);
  // formdata.append("is_multifaced", data.is_multifaced);
  // formdata.append("is_premium", data.is_premium);
  // formdata.append("is_trending", data.is_trending);premiumfor
  formdata.append("premiumfor", data.premiumfor);

  // Append images with specified filenames
  data.files.forEach((file, index) => {
    const fileName = ` (${index + 2}).png`; // Creates file names like " (2).png", " (3).png", etc.
    formdata.append("files", file, fileName);
  });

  console.log(formdata);
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `token ${API_TOKEN}`,
    },
    body: formdata,
  };

  try {
    const response = await fetch(
      `${API_URL}/api/add_template_and_category/v2`,
      requestOptions,
    );

    console.log(response);

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} - ${response.statusText}`);
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error in addCategoryWithTemplates:", error);
    throw error;
  }
};

const deleteTemplate = async (templateId) => {
  const formdata = new FormData();
  formdata.append("template_id", templateId);

  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: `token ${API_TOKEN}`,
    },
    body: formdata,
  };

  try {
    const response = await fetch(
      `${API_URL}/api/delete_template/`,
      requestOptions,
    );

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} - ${response.statusText}`);
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error in deleteTemplate:", error);
    throw error;
  }
};

export { getRandomTemplates, addCategoryWithTemplates, deleteTemplate };
